import { RestClient } from '@/modules/axios';

export default {
    state: {
        formClientModule: null,
        sheets: null,
    },
    getters: {
        getSheets(state) {
            return state.sheets;
        },
    },
    mutations: {
        setSheets(state, payload) {
            state.sheets = payload;
        },
    },
    actions: {
        fetchReceiptDetails({ dispatch }, payload) {
            return dispatch('getFormClientModule')
                .then((form) => {
                    return form.postFormData('/api/liquidity', payload).then(() => {
                        return Promise.resolve();
                    });
                })
                .catch((error) => {
                    console.log('error', error);

                    return Promise.reject();
                });
        },

        getFormClientModule(context) {
            !context.state.formClientModule ? (context.state.formClientModule = new RestClient('', context)) : null;
            return context.state.formClientModule;
        },

        fetchSheets({ commit, dispatch }) {
            return dispatch('getFormClientModule')
                .then((sheets) => {
                    return sheets.get('/api/google_sheets').then((result) => {
                        commit('setSheets', result.data);
                        return Promise.resolve();
                    });
                })
                .catch(() => {
                    return Promise.reject();
                });
        },
    },
};
